import ApiBase from 'thsc-ifind-stock-f9/packages/assets/js/apiBase.js';
import { requestGet, requestPost, CancelToken } from 'thsc-ifind-stock-f9/packages/assets/js/request.js';

export default {
  ApiBase,
  requestGet,
  requestPost,
  CancelToken,
}
